const BASE_URL = "http://army-backend.com";
export { BASE_URL };
